module.exports = __webpack_public_path__ + "static/media/GrayCircle.5a419419.svg";